import { IGroupData } from '@df/catalog/cms/cms-model.interface';
import { ICmsModel } from '../model/icms-model';

export class ICmsGroup extends ICmsModel<IGroupData, number> {
    /**
     * Object type id
     */
    static override readonly type = 'group';

    /**
     * Max verbosity
     */
    override readonly maxVerbosity = 1;

    /**
     * If works with scope data
     */
    override readonly hasScopeData = false;
}
